import { Injectable, inject } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  protected readonly logger = inject(LoggingService);

  protected validateMandatory(toValidate: string | undefined, message: string): asserts toValidate is string {
    if (!toValidate) {
      const error = new Error(`${message}: mandatory parameters error`);

      this.logger.error({ message: $localize`Mandatory parameters error: ${message}`, error });
      throw error;
    }
  }
}
